/**
 * Minimalist Product Page Interactive Logic (Yeezy.com Style)
 * - Media Carousel (< > arrows and dots)
 * - Description Accordion Toggle (+ / ×)
 * - Scroll down to next product in catalog
 */

document.addEventListener('DOMContentLoaded', () => {
  initMinimalCarousel();
  initDescriptionToggle();
  initScrollToNextProduct();
});

/**
 * 1. Media Carousel Logic
 */
function initMinimalCarousel() {
  const slides = document.querySelectorAll('.minimal-slide');
  const dots = document.querySelectorAll('.minimal-dot');
  const prevBtn = document.querySelector('.minimal-arrow--prev');
  const nextBtn = document.querySelector('.minimal-arrow--next');

  if (!slides.length) return;

  let currentIndex = 0;

  function showSlide(index) {
    if (index < 0) {
      currentIndex = slides.length - 1;
    } else if (index >= slides.length) {
      currentIndex = 0;
    } else {
      currentIndex = index;
    }

    slides.forEach((slide, idx) => {
      if (idx === currentIndex) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });

    dots.forEach((dot, idx) => {
      if (idx === currentIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      showSlide(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      showSlide(currentIndex + 1);
    });
  }

  dots.forEach((dot, idx) => {
    dot.addEventListener('click', () => {
      showSlide(idx);
    });
  });

  // Initialize first slide
  showSlide(0);
}

/**
 * 2. Description Toggle (+ / × button)
 */
function initDescriptionToggle() {
  const toggleBtn = document.getElementById('MinimalInfoBtn');
  const descContainer = document.getElementById('MinimalDescription');

  if (!toggleBtn || !descContainer) return;

  let isOpen = false;

  toggleBtn.addEventListener('click', () => {
    isOpen = !isOpen;
    if (isOpen) {
      descContainer.classList.add('is-open');
      toggleBtn.innerHTML = 'CERRAR';
      toggleBtn.setAttribute('aria-expanded', 'true');
    } else {
      descContainer.classList.remove('is-open');
      toggleBtn.innerHTML = 'INFORMACION';
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });
}

/**
 * 3. Scroll / Swipe to Next Product
 */
function initScrollToNextProduct() {
  const nextUrl = window.minimalNextProductUrl;
  if (!nextUrl) return;

  let accumulatedDeltaY = 0;
  let isNavigating = false;

  // Desktop wheel scroll handler
  window.addEventListener('wheel', (e) => {
    if (isNavigating) return;

    // Check if user is at the bottom of the page
    const isAtBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 10);

    if (e.deltaY > 0 && isAtBottom) {
      accumulatedDeltaY += e.deltaY;
      // When threshold is reached, navigate
      if (accumulatedDeltaY > 150) {
        navigateToNextProduct(nextUrl);
      }
    } else {
      accumulatedDeltaY = 0;
    }
  }, { passive: true });

  // Mobile Touch swipe handler
  let startTouchY = 0;
  window.addEventListener('touchstart', (e) => {
    if (e.touches.length === 1) {
      startTouchY = e.touches[0].clientY;
    }
  }, { passive: true });

  window.addEventListener('touchend', (e) => {
    if (isNavigating) return;
    const endTouchY = e.changedTouches[0].clientY;
    const deltaY = startTouchY - endTouchY; // Positive when swiping up (scrolling down)
    const isAtBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 20);

    if (deltaY > 80 && isAtBottom) {
      navigateToNextProduct(nextUrl);
    }
  }, { passive: true });

  function navigateToNextProduct(url) {
    if (isNavigating) return;
    isNavigating = true;
    document.body.style.transition = 'opacity 0.4s ease';
    document.body.style.opacity = '0';
    setTimeout(() => {
      window.location.href = url;
    }, 400);
  }
}
